import React from 'react';
import { XIcon } from 'lucide-react';
const PAIN_POINTS = [{
  lead: 'Lo ves más quieto cada semana.',
  rest: 'La tele prendida todo el día, la siesta que se estira, cada vez menos charla.'
}, {
  lead: 'Buscaste “ejercicios de memoria para abuelos” y terminaste con 30 PDFs sueltos:',
  rest: 'en letra chiquita, en inglés o pensados para chicos.'
}, {
  lead: 'El médico te dijo “que se mueva y que ejercite la cabeza”.',
  rest: 'Perfecto. ¿Pero qué ejercicio, cuánto tiempo y cómo, sin que se caiga ni se frustre?'
}, {
  lead: 'Tenés la medicación, la presión y los estudios desparramados',
  rest: 'entre la heladera, un cajón y el WhatsApp.'
}, {
  lead: 'Hacés casi todo vos,',
  rest: 'y tus hermanos “ayudan cuando pueden”. El cansancio ya se nota.'
}];
export const PainSection = () => {
  return <section id="dolor" className="bg-familia-light py-12 md:py-16 px-4 md:px-6" data-id="element-167" data-mp="2298672cd1b8f">
      <div className="max-w-5xl mx-auto w-full" data-id="element-168" data-mp="2792wb3ob9wsf">
        <h2 className="text-[26px] sm:text-3xl md:text-4xl font-display font-bold text-center text-familia-ink mb-8 md:mb-12 leading-tight" data-id="element-169" data-mp="277rtb62owt2d">
          ¿Te pasa algo de esto?
        </h2>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4" data-id="element-170" data-mp="3nknrf5clrcem">
          {PAIN_POINTS.map(item => <li key={item.lead} className="bg-familia-lightCard border border-familia-lightBorder p-5 md:p-6 rounded-xl flex items-start gap-4" data-id="element-171" data-mp="5ehmuob8zpmo">
              <span className="w-8 h-8 rounded-full bg-familia-urgent/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-172" data-mp="38wj4tqafigqk">
                <XIcon className="w-5 h-5 text-familia-urgent" strokeWidth={3} aria-hidden="true" data-id="element-173" data-mp="33y7tfb4hjy68" />
              </span>
              <p className="text-body text-familia-inkMuted" data-id="element-174" data-mp="3in4ce382yvlm">
                <span className="font-bold text-familia-ink" data-id="element-175" data-mp="3dvw111n6x05t">{item.lead}</span>{' '}
                {item.rest}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
};